// Module
var code = "<div class=\"app-main__header app-main__header--interior\"> <div class=\"app-main__header--interior__content\"> <bm-back-link></bm-back-link> </div> </div> <article class=\"app-main__content-area content-area\"> <div class=\"mb-32 alert alert-danger\">This horse either doesn't exist or you don't have access to it.</div> </article> ";
// Exports
module.exports = code;